import EventPanel from "./EventPanel";

// "Veranstaltungen" — event calendar (poi_event + recurring poi_schedule rules)
const eventModule = {
  fallbackLabel: "Veranstaltungen",
  Panel: EventPanel,
};

export default eventModule;
